import { render, staticRenderFns } from "./patientRegister.vue?vue&type=template&id=120d6895&scoped=true&"
import script from "./patientRegister.vue?vue&type=script&lang=js&"
export * from "./patientRegister.vue?vue&type=script&lang=js&"
import style0 from "./patientRegister.vue?vue&type=style&index=0&id=120d6895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d6895",
  null
  
)

export default component.exports